export default __webpack_public_path__ + "static/media/fb_profile_icon.f321e551.svg";